import React from 'react';
import SwitchAB from "./SwitchAB";
import Config from "../../config/Config";

const SwitchA = ({extraStyle}) => {
    const features = [
        {
            title: Config.messages.fasterTitle,
            description: Config.messages.fasterDescription,
            image: Config.images.FEATURE_FASTER
        },
        {
            title: Config.messages.advancedTitle,
            description: Config.messages.advancedDescription,
            image: Config.images.FEATURE_ADVANCED
        },
        {
            title: Config.messages.privacyTitle,
            description: Config.messages.privacyDescription,
            image: Config.images.FEATURE_PRIVACY
        }
    ];

    return (<SwitchAB features={features} extraStyle={extraStyle}/>)
};

export default SwitchA;
